<template>
  <h1>{{ $t('reuniao.UMA_LANG_CONSELHOGERAL_REUNIAO_NUMEROTEXTO') }} {{ numero }}</h1>
  <h5>{{ $t('reuniao.UMA_LANG_CONSELHOGERAL_REUNIAO_DATAEHORA') }}</h5>
  <p>{{ formatedData }} - {{ hora }}</p>
  <h5>{{ $t('reuniao.UMA_LANG_CONSELHOGERAL_REUNIAO_ATAS') }}</h5>
  <p v-html="formattedAtas"></p>
  <h5>{{ $t('reuniao.UMA_LANG_CONSELHOGERAL_REUNIAO_DELIBERACOES') }}</h5>
  <p v-html="deliberacoes"></p>
  <h5>{{ $t('reuniao.UMA_LANG_CONSELHOGERAL_REUNIAO_DOCUMENTACAO') }}</h5>
  <p v-html="formattedDocumentos"></p>
</template>

<script>
import { computed } from "vue";

export default {
  props: ["numero","data","hora","deliberacoes","atas","documentos"],
  setup(props){

    const formattedAtas = computed(() => {
      if (!props.atas) return "";
      let atas = props.atas;
      atas = atas.replace("<ul><br />", "<ul>");
      atas = atas.replace("<ul><br/>", "<ul>");
      atas = atas.replace("<br /></ul>", "</ul>");
      atas = atas.replace("<br/></ul>", "</ul>");
      atas = atas.replace("<br />\r\n</ul>", "</ul>");
      atas = atas.replace("<br/>\r\n</ul>", "</ul>");
      atas = atas.replace(/^<p>/, "").replace(/<\/p>$/, "");
      return atas;
    });

    const formattedDocumentos = computed(() => {
      if (!props.documentos) return "";
      let documentos = props.documentos;
      documentos = documentos.replace("<ul><br />", "<ul>");
      documentos = documentos.replace("<ul><br/>", "<ul>");
      documentos = documentos.replace("<br /></ul>", "</ul>");
      documentos = documentos.replace("<br/></ul>", "</ul>");
      documentos = documentos.replace("<br />\r\n</ul>", "</ul>");
      documentos = documentos.replace("<br/>\r\n</ul>", "</ul>");
      documentos = documentos.replace("</li><br/>", "</li>");
      documentos = documentos.replace("</li><br />", "</li>");
      documentos = documentos.replace(/^<p>/, "").replace(/<\/p>$/, "");
      return documentos;
    });

    const formatedData = computed(() => {
      if (!props.data) return "";
      const date = new Date(props.data);
      if (isNaN(date.getTime())) {
        return ""; 
      }
      const formatter = new Intl.DateTimeFormat("pt-PT", { 
        day: "2-digit", 
        month: "2-digit", 
        year: "numeric" 
      });
      return formatter.format(date);
    });


    return {
      formattedAtas,
      formattedDocumentos,
      formatedData
    };

  }
}
</script>

<style lang="scss" scoped>
.bolsa_detalhe h5 {
  font-size: 12px;
  font-family: "Montserrat Semibold";
  text-transform: uppercase;
  color: #535d61;
  margin-bottom: 0px;
}

.bolsa_detalhe h1 {
  font-family: "Montserrat Bold";
  font-size: 24px;
  padding-bottom: 10px;
  margin-top: 50px;
  color: #535d61;
}

.bolsa_detalhe h2 {
  color: #6eb7ec;
  font-family: "Montserrat Bold";
  font-size: 20px;
  padding-bottom: 28px;
}

.bolsa_detalhe p {
  font-family: "Montserrat";
  font-size: 16px;
  margin-bottom: 30px;
  margin-top: 5px;
  font-family: 'PT Sans';
  color: #656565;
}

:deep(a) {
  font-family: "PT Sans Bold" !important;
  text-decoration: underline !important;
  color: #1779ba !important;
}

@media (min-width : 768px) and (max-width : 1024px) {
  .bolsa_detalhe h1 {
    font-size: 20px;
    margin-top: 35px;
  }

  .bolsa_detalhe h2 {
    font-size: 18px;
  }

  .bolsa_detalhe p {
    font-size: 15px;
    margin-bottom: 20px;
  }

}

@media screen and (max-width:767px) {
  .bolsa_detalhe h1 {
    font-size: 16px;
    margin-top: 10px;
    padding-top: 15px;
    margin-bottom: 0px;
    padding-bottom: 5px;
  }

  .bolsa_detalhe h2 {
    font-size: 16px;
    padding-top: 5px;
    padding-bottom: 20px;
  }

  .servico_bolsas_detalhe h5 {
    font-size: 12px;
  }

  .servico_bolsas_detalhe p {
    font-size: 14px;
    margin-bottom: 20px;
  }
}
</style>